import React from "react";
import "./Financials.css";

export default function FinancialTabs({
  activeTab = "profit_loss",
  setActiveTab,
}) {
  return (
    <div className="business_seg_tabs">
      <div className="navbar navbar-expand-lg container-fluid custom_subnavbar_custom">
        <ul className="nav nav-tabs custom_nav_tab">
          <li className="nav-item">
            <a
              className={`nav-link ${
                activeTab === "key_statistics" ? "active" : ""
              }`}
              onClick={() => setActiveTab("key_statistics")}
            >
              Key Statistics
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${
                activeTab === "profit_loss" ? "active" : ""
              }`}
              onClick={() => setActiveTab("profit_loss")}
            >
              Profit & Loss
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${
                activeTab === "balance_sheet" ? "active" : ""
              }`}
              onClick={() => setActiveTab("balance_sheet")}
            >
              Balance Sheet
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${
                activeTab === "cash_flow" ? "active" : ""
              }`}
              onClick={() => setActiveTab("cash_flow")}
            >
              Cash Flows
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "ratios" ? "active" : ""}`}
              onClick={() => setActiveTab("ratios")}
            >
              Ratios
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
